export interface ArticleItem {
  id: string;
  title: string;
  coverImage: string;
  category: string;
  summary: string;
  content: string;
  author: string;
  publishDate: string;
  readCount: string;
  tags: string[];
}

export const articles: ArticleItem[] = [
  {
    id: 'a001',
    title: '2024年最值得期待的十大国产剧盘点',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collection%20collage%20style%20with%20multiple%20drama%20posters%2C%20entertainment%20news%20banner%2C%20warm%20gradient%20background%2C%20editorial%20design&width=1200&height=628&seq=article-cover-001&orientation=landscape',
    category: '影视资讯',
    summary: '随着国产剧制作水平的不断提升，2024年涌现出了一大批高质量剧集。本文将为你盘点今年最值得关注的十部国产精品剧，涵盖古装、都市、悬疑等多个类型。',
    content: `<h2>国产剧市场蓬勃发展</h2><p>2024年，国产剧市场迎来了前所未有的繁荣期。各大平台纷纷加大投入，制作水平显著提升，涌现出了一批口碑与收视双丰收的精品剧集。</p><h2>古装剧持续霸屏</h2><p>古装剧依然是观众最喜爱的类型之一。《古剑传说之仙缘》凭借精美的服化道和宏大的世界观，成为了今年最热门的仙侠剧。《山河令之风云再起》则以紧凑的剧情和出色的武打设计，收获了极高的口碑。</p><h2>现代剧质量飞跃</h2><p>现代题材剧集同样表现亮眼。《春风十里不如你》以细腻的情感刻画赢得了观众的共鸣，《暗夜追踪者》则用烧脑的剧情吸引了大量悬疑剧爱好者。</p><h2>历史剧回归巅峰</h2><p>《大秦帝国之纵横天下》延续了系列一贯的高水准制作，无论是演员表演还是场景还原都堪称一流，豆瓣评分高达9.7分，成为年度评分最高的国产剧。</p>`,
    author: '影视观察员小王',
    publishDate: '2024-07-15',
    readCount: '12.8万',
    tags: ['国产剧', '盘点', '推荐']
  },
  {
    id: 'a002',
    title: '深度解析：《深海迷踪》背后的科学原理',
    coverImage: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20scientific%20exploration%20scene%20with%20submarine%20and%20marine%20life%2C%20educational%20article%20banner%2C%20blue%20ocean%20gradient%2C%20science%20communication%20style&width=1200&height=628&seq=article-cover-002&orientation=landscape',
    category: '影视资讯',
    summary: '《深海迷踪》不仅是一部视觉震撼的科幻大片，其中涉及的海洋科学知识同样值得探讨。本文带你深入了解电影背后的真实科学。',
    content: `<h2>深海探索的现状</h2><p>人类对深海的了解甚至少于对月球表面的了解。目前全球仅有约20%的海底被绘制成高分辨率地图。电影《深海迷踪》中展现的深海场景，很大程度上基于真实的海洋科学研究。</p><h2>深海生物的真实面貌</h2><p>电影中出现的深海生物虽然经过艺术加工，但其设计灵感来源于真实存在的深海物种。深海生物为了适应极端环境，进化出了各种独特的生存策略，如生物发光、透明身体等。</p><h2>深海探测技术</h2><p>影片中展示的深海探测器，参考了目前世界上先进的载人深潜器设计。中国的"奋斗者"号载人潜水器已经能够下潜到万米深海，这些真实的技术突破为电影创作提供了丰富的素材。</p>`,
    author: '科幻迷老张',
    publishDate: '2024-09-05',
    readCount: '8.2万',
    tags: ['科幻', '科普', '深海迷踪']
  },
  {
    id: 'a003',
    title: '从《古剑传说》看国产仙侠剧的进化之路',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20evolution%20timeline%20design%2C%20traditional%20to%20modern%20visual%20effects%2C%20golden%20and%20ethereal%20color%20palette%2C%20editorial%20banner&width=1200&height=628&seq=article-cover-003&orientation=landscape',
    category: '深度影评',
    summary: '从五毛特效到大片质感，国产仙侠剧经历了怎样的蜕变？以《古剑传说之仙缘》为例，剖析国产仙侠剧在特效、叙事和美学上的全面升级。',
    content: `<h2>仙侠剧的前世今生</h2><p>回顾国产仙侠剧的发展历程，从早期的《仙剑奇侠传》到如今的《古剑传说之仙缘》，可以看到一条清晰的进化路径。早期的仙侠剧受限于技术条件，特效制作相对简陋，但凭借出色的剧情和人物塑造，依然成为了经典。</p><h2>技术驱动视觉升级</h2><p>近年来，随着CGI技术的成熟和制作预算的增加，国产仙侠剧的视觉效果有了质的飞跃。《古剑传说之仙缘》大量运用了虚拟拍摄和实时渲染技术，让仙侠世界的呈现更加真实可信。</p><h2>叙事手法的革新</h2><p>除了视觉效果，现代仙侠剧在叙事手法上也更加多样化。非线性叙事、多线并行等手法被广泛运用，让故事更加丰富立体。同时，角色塑造也更加注重内心世界的刻画。</p>`,
    author: '影评人阿杰',
    publishDate: '2024-08-20',
    readCount: '15.6万',
    tags: ['仙侠剧', '特效', '影评']
  },
  {
    id: 'a004',
    title: '麻豆精品影视网独家专访：导演陈凯歌谈创作心路',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20director%20interview%20scene%20in%20studio%20with%20professional%20lighting%2C%20cinematic%20atmosphere%2C%20warm%20tones%2C%20editorial%20photography%20style&width=1200&height=628&seq=article-cover-004&orientation=landscape',
    category: '独家专访',
    summary: '我们有幸邀请到著名导演陈凯歌，畅谈《古剑传说之仙缘》的创作历程，分享他对中国影视行业未来发展的独到见解。',
    content: `<h2>创作初衷</h2><p>在被问及为何选择拍摄仙侠题材时，陈凯歌导演表示："中国传统文化中有取之不尽的创作素材，仙侠世界承载着中国人对理想世界的想象。我希望通过这部作品，让更多年轻观众感受到传统文化的魅力。"</p><h2>挑战与突破</h2><p>陈凯歌坦言，拍摄仙侠剧最大的挑战在于如何平衡商业性与艺术性。"视觉特效是工具，不是目的。好的作品应该在震撼的视觉效果之外，传递打动人心的情感和思考。"</p><h2>行业展望</h2><p>对于中国影视行业的未来，陈凯歌充满信心："我们拥有深厚的文化底蕴和优秀的创作人才，只要坚持品质，中国影视作品走向世界指日可待。"</p>`,
    author: '麻豆编辑部',
    publishDate: '2024-06-30',
    readCount: '22.1万',
    tags: ['专访', '陈凯歌', '古剑传说']
  },
  {
    id: 'a005',
    title: '悬疑剧迷必看：《暗夜追踪者》十大未解之谜',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20crime%20drama%20analysis%20article%20banner%2C%20dark%20detective%20theme%2C%20magnifying%20glass%20and%20evidence%2C%20noir%20atmosphere%2C%20suspenseful%20mood&width=1200&height=628&seq=article-cover-005&orientation=landscape',
    category: '深度影评',
    summary: '《暗夜追踪者》结局虽然已经揭晓，但剧中仍有许多细节值得反复品味。本文梳理了剧中十大令人回味的谜题和伏笔。',
    content: `<h2>开放式结局的多重解读</h2><p>《暗夜追踪者》的结局采用了开放式处理，给观众留下了丰富的想象空间。主角最后的选择究竟意味着什么？是正义的胜利还是妥协的开始？不同的观众可能有完全不同的解读。</p><h2>隐藏线索回顾</h2><p>细心的观众会发现，剧中埋藏了大量的伏笔和细节。从前几集看似无关的对话，到背景中的细节画面，都在为最后的真相做铺垫。这种精心设计的叙事结构，体现了编剧团队的功力。</p>`,
    author: '悬疑控小林',
    publishDate: '2024-07-28',
    readCount: '18.3万',
    tags: ['悬疑', '分析', '暗夜追踪者']
  },
  {
    id: 'a006',
    title: '综艺新风向：《美食侦探社》为何火爆全网',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20variety%20show%20article%20banner%2C%20colorful%20dishes%20and%20celebrities%2C%20cheerful%20entertainment%20atmosphere%2C%20appetizing%20food%20photography&width=1200&height=628&seq=article-cover-006&orientation=landscape',
    category: '影视资讯',
    summary: '一档将美食与探案结合的创新综艺，凭借独特的节目形式和明星嘉宾的化学反应，成为2024年最火爆的综艺节目之一。',
    content: `<h2>节目形式创新</h2><p>《美食侦探社》巧妙地将美食探店与悬疑探案两大元素结合，每期节目邀请不同的明星嘉宾组成"侦探团"，在品尝美食的同时破解与美食相关的谜题。这种"美食+推理"的模式在国内综艺市场独树一帜。</p><h2>嘉宾化学反应</h2><p>黄磊的厨艺担当、张亮的专业点评、谢霆锋的挑剔味蕾加上杨紫的可爱表现，四位常驻嘉宾各具特色，互动自然有趣。飞行嘉宾的加入也为节目增添了新鲜感。</p>`,
    author: '综艺观察员',
    publishDate: '2024-08-10',
    readCount: '9.7万',
    tags: ['综艺', '美食', '分析']
  }
];

export const getArticleById = (id: string): ArticleItem | undefined => {
  return articles.find(a => a.id === id);
};

export const getArticlesByCategory = (category: string): ArticleItem[] => {
  return articles.filter(a => a.category === category);
};